import {initFederation} from '@angular-architects/native-federation';
import {setFederation} from './app/utils/federation';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(err => console.error('SW registration failed:', err));
}

async function initializeFederation() {
  try {
    const routes = await fetch('/web/apps/routes').then(res => res.json());

    const manifest: Record<string, string> = {};

    routes.forEach((route:any) => {
      manifest[route.path] = route.remoteEntry;
    });

    // 'always' + overrideCachedRemotesIfURLMatches : permet à initRemoteEntry (cf. RoutesLoaderService.refreshRemote)
    // de recharger le remoteEntry.json d'une remote déjà enregistrée après un redéploiement.
    const federation = await initFederation(manifest, {
      profile: {overrideCachedRemotes: 'always', overrideCachedRemotesIfURLMatches: true}
    });
    setFederation(federation);
    await import('./bootstrap');
  } catch (err) {
    console.error('Error during federation initialization:', err);
  }
}

initializeFederation();

